import { Trash2 } from 'lucide-react';
import React from 'react';

import { Button } from '@/Components/shadcn/button';
import { TypographyH4 } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';

export interface CriteriaFieldLabelProps {
    index: number;
    showDeleteButton: boolean;
    disabled?: boolean;
    onRemove?: () => void;
}

const CriteriaFieldLabel = ({ index, showDeleteButton, disabled, onRemove }: CriteriaFieldLabelProps) => {
    return (
        <div className="flex w-full items-end justify-between">
            <TypographyH4 className="text-foreground">{UIStrings.Criteria(index + 1)}</TypographyH4>
            {showDeleteButton && (
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    aria-label="delete"
                    disabled={disabled}
                    onClick={onRemove}
                >
                    <Trash2 className="text-primary size-5" />
                </Button>
            )}
        </div>
    );
};

export default CriteriaFieldLabel;
